import React from "react";
import { IOption } from "component-library/src/components/Atoms/FormikInputs/SelectFormik/SelectFormik";

import { profileService } from "../services";

type IPhotographerNameOptionsMap = {
  [searchTerm: string]: IOption[];
};

export const usePhotographerNameOptions = () => {
  const [optionsMap, setOptionsMap] =
    React.useState<IPhotographerNameOptionsMap>({});

  const retrieveOptions = async (searchTerm?: string) => {
    if (!searchTerm || searchTerm.length < 3) {
      return [] as IOption[];
    }

    // check options exist in cache
    if (optionsMap[searchTerm]) {
      return optionsMap[searchTerm];
    }

    try {
      const { names } = await profileService.getMatchingPhotographerNames(
        searchTerm
      );

      if (!names || names.length === 0) return [] as IOption[];

      const nameOptions = names.map((name) => ({
        value: name,
        label: name,
      })) as IOption[];

      setOptionsMap((currentOptionsMap) => ({
        ...currentOptionsMap,
        [searchTerm]: nameOptions,
      }));

      return nameOptions;
    } catch (error: any) {
      console.error(error);

      return [] as IOption[];
    }
  };

  return { getPhotographerNameOptions: retrieveOptions };
};
